import React from "react";
import Markdown from "markdown-to-jsx";

import { Message } from "../Message";

export interface DefaultTextProps {
  /** Content to render in message bubble */
  text: string;
  /** Optional callback when a link is clicked */
  onLinkClick?: (href: string) => void;
}

/** Render text message in markdown */
export const Text: React.FC<DefaultTextProps> = ({ text, onLinkClick }) => {
  return (
    <Message direction="system">
      <Markdown
        options={{
          overrides: {
            a: {
              component: ({
                href,
                children,
                ...props
              }: React.AnchorHTMLAttributes<HTMLAnchorElement> & {
                href?: string;
              }) => {
                const handleClick = () => {
                  if (href && onLinkClick) {
                    onLinkClick(href);
                  }
                };

                return (
                  <a
                    {...props}
                    href={href}
                    target="_blank"
                    rel="noopener"
                    onClick={handleClick}
                  >
                    {children}
                  </a>
                );
              },
            },
          },
        }}
      >
        {text}
      </Markdown>
    </Message>
  );
};
